import { useMutation } from "react-query";
import organizationRisk from "../services/organizationRisk";

const useOrganizationRisk = () => {
  return useMutation(["organization-risk"], organizationRisk);
};

export default useOrganizationRisk;
